import { ChangeDetectorRef, Component, inject, Input } from '@angular/core'

import { Closeable } from '@app/overlays/closeable'
import { UIModule } from '@ui/ui.module'

@Component({
  selector: 'sb-upload-status',
  templateUrl: './upload-status.component.html',
  imports: [UIModule],
  styleUrl: '../../../../overlays/modal/modal-content.scss',
})
export class UploadStatusComponent extends Closeable {
  private readonly changeDetectorRef = inject(ChangeDetectorRef)

  @Input({ required: true }) count!: number
  @Input({ required: true }) mediaType!: 'Photo' | 'Video'

  progress = 0

  get parsedProgress(): number {
    return Math.ceil(this.progress / 5) * 5
  }

  updateProgress(value: number) {
    this.progress = value
    this.changeDetectorRef.markForCheck()
  }
}
